<template>
  <div class="percentage-box">
    <!-- <div class="box"> -->
    <div class="icon"
         :style="{ 'background-color': getBgColor }">
      <slot name="icon"/>
    </div>

    <div class="text-content">
      <p class="title">
        {{ boxData.title }}
      </p>

      <h3 class="value">
        {{ boxData.value }}
      </h3>
    </div>
    <!-- </div> -->

    <slot name="content">
      <p v-if="boxData.percentage"
         class="text"
         :style="{ color: getColor }">
        {{ isNaN(boxData.percentage) ? 0 : boxData.percentage }}%
      </p>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'PercentageBox',
    props: {
      boxData: {
        type: Object,
        required: true,
      },
    },
    computed: {
      getBgColor() {
        return `var(--${this.boxData.color})`;
      },
      getColor() {
        return `var(--${this.boxData.color}0)`;
      },
    },
  };
</script>

<style lang="scss" scoped>
.percentage-box {
  width: 100%;
  display: flex;
  align-items: end;
  gap: 8px;
  height: 100%;
  flex-wrap: wrap;

  @include responsive(max, 768px) {
    align-items: unset;
    gap: 16px;
  }

  .icon {
    width: 64px;
    height: 64px;
    border-radius: 4px;
    background-color: var(--color-base-50);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    @include responsive(max, 768px) {
      width: 32px;
      height: 32px;
    }
  }

  .text-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 64px;

    @include responsive(max, 768px) {
      height: fit-content;
      gap: 8px;
      width: 100%;
      order: 3;
    }

    .title {
      color: var(--gray500);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 1;

      @include responsive(max, 768px) {
        font-size: 12px;
        font-weight: 500;
      }
    }

    .value {
      color: var(--gray900);
      font-size: 28px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px;

      @include responsive(max, 768px) {
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
      }
    }
  }

  .text {
    margin-inline-start: auto;
    color: var(--color-base-500);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 1;

    @include responsive(max, 768px) {
      font-size: 12px;
      font-weight: 600;
      line-height: 12px;
    }
  }
}
</style>
